import { SearchRequest } from '@hclinear/hc-linear-react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { TerminalStatusFilterDTO } from '@/model';
import { searchTerminalStatusAPI } from '@/service';

const searchTerminalStatusBaseQueryKey = 'searchTerminalStatus';

export const useSearchTerminalStatusQuery = (
  request: SearchRequest<Partial<TerminalStatusFilterDTO>>,
) => {
  return useQuery({
    queryKey: [searchTerminalStatusBaseQueryKey, request],
    queryFn: () => searchTerminalStatusAPI(request).then((result) => result.data),
    enabled: !!request.filters?.productSnId,
    placeholderData: keepPreviousData,
  });
};
